import { useEffect, useRef } from 'react'
import styles from './Downloads.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import LeftContents from './LeftContents'
import { LeftContentDataType } from './types/types'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

gsap.registerPlugin(ScrollTrigger)

const leftContentData: LeftContentDataType = {
  titleVol: <>デザインプロセスガイドブック</>,
  alt: 'デザインプロセスガイドブック',
  readText: <>開発まで考慮されたUI/UXデザインにおける弊社の考え方や、デザインプロセスの全体について紹介</>,
  imgLarge: '/images/img/download/design-process/thumbnail_dp.webp',
  imgCapture: '/images/img/download/design-process/capture_dp.webp',
  firstContentTitle: 'このような方におすすめ',
  firstHalf: (
    <>
      この資料ではUI/UXデザインにおける私たちの考え方や、特徴と強みについて解説しております。開発フェーズまで考慮し、ロジカルで納得感のある構造設計の手法や、弊社の提供する10のデザインサービス一覧を紹介してます。開発フェーズまで考慮されたUI/UXデザイン、デザインシステムの情報収集をされている方におすすめの資料です。
    </>
  ),
  secondContentTitle: 'この資料でわかること',
  secondHalf1: '延べ500社以上のご支援で培ったUI/UXデザインのプロセス',
  secondHalf2: '代表的な3つのプロジェクト事例について',
  secondHalf3: '弊社のプロジェクトの進め方、特徴と強み',
}

const DownloadDesignProcess: React.FC = () => {
  const title_category = useRef<HTMLSpanElement>(null)
  const title_page = useRef<HTMLSpanElement>(null)
  useHubSpotGenerate('na1', '9395227', '8b81a272-014a-4af8-9369-7b075c185051', '#hbspt')
  useEffect(() => {
    gsap.set([title_category.current, title_page.current, `.${styles.read_text}`, `.${styles.section}`], { opacity: 0, y: 50 });

    const timeline = gsap.timeline({
      defaults: {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: Power4.easeOut,
      },
    });

    const commonTo = { opacity: 1, y: 0 };

    timeline
      .to(title_category.current, commonTo, 0.2)
      .to(title_page.current, commonTo, 0.5)
      .to(`.${styles.read_text}`, commonTo, 0.8)
      .to(`.${styles.section}`, commonTo, 1.1);
  }, [])

  return (
    <article className={`${styles.main} downloadArea`}>
      <section className={styles.contents}>
        <h1 className={styles.ttl}>
          <span ref={title_category}>Download</span>
         <span ref={title_page}>{leftContentData.titleVol}</span>
        </h1>
        <p className={styles.read_text}>{leftContentData.readText}</p>
        <section className={styles.section}>
          <LeftContents
            leftContentData={leftContentData}
            isSecondContent={true}
          />
          <div className={styles.content}>
            <div className={styles.title_group}>
              <p className={styles.whitepaper}>
                ご入力いただいたメールアドレス宛に、資料ダウンロード用URLを送付いたします。
              </p>
              <p className={styles.notice}>※ 全ての項目をご入力ください。</p>
            </div>
            <div id="hbspt"></div>
          </div>
        </section>
      </section>
      <MailmagazineLink />
    </article>
  )
}

export default DownloadDesignProcess
